module.exports = __webpack_public_path__ + "static/img/PrestationEnfant.97bb6dd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/PrestationEnfant.jpg
// module id = V3CS
// module chunks = 1